export default "__VITE_ASSET__DNw1GZuE__"